/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Option } from "@nordcloud/gnui/dist/components/dropdown/types";
import { useFormContext } from "react-hook-form";
import { OvDropdown } from "~/components/Forms/OvDropdown";
import {
  SidebarFormField,
  SidebarFormFieldProps,
} from "~/components/SidebarForm/SidebarFormField";

type Props = {
  name: string;
  options: Option[];
  defaultValue?: string;
  disabled?: boolean;
} & SidebarFormFieldProps;

function SidebarDropdown(props: Props) {
  const { register, watch, setValue } = useFormContext();

  React.useEffect(() => {
    register({ name: props.name });
  }, [props, register]);

  React.useEffect(() => {
    setValue(props.name, props.defaultValue);
  }, [setValue, props.name, props.defaultValue]);

  return (
    <SidebarFormField
      label={props.label}
      required={props.required}
      tooltip={props.tooltip}
    >
      <OvDropdown
        name={props.name}
        onChange={(val: string) => {
          setValue(props.name, val);
        }}
        value={watch(props.name)}
        options={props.options}
        placeholder={props.label}
        disabled={props.disabled}
      />
    </SidebarFormField>
  );
}

export { SidebarDropdown };
